import { render, staticRenderFns } from "./decompose.vue?vue&type=template&id=545f56c4&"
import script from "./decompose.vue?vue&type=script&lang=js&"
export * from "./decompose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports